import React from 'react'
import Fallback from 'components/SA/Fallback'
import { ERROR_DATA, TILES_DATA, PDP_ERROR_MESSAGE } from './helpers'
import TileList from 'components/SA/Fallback/Tiles/TilesList'
import styles from './Error.module.scss'
type Props = {
  message?: string
  statusCode?: number
}
const Error = (props: Props) => {
  const { statusCode, message } = props
  const { subTitleGeneral, subTitlePDP, description } = ERROR_DATA
  return (
    <Fallback
      title={statusCode ? String(statusCode) : '404'}
      subTitle={message === PDP_ERROR_MESSAGE ? subTitlePDP : subTitleGeneral}
      description={description}
    >
      <div className={styles.tilesRow}>
        <p>Explore These In The Meantime</p>
        <TileList tiles={TILES_DATA} />
      </div>
    </Fallback>
  )
}
export default Error
